var map = {
	"./activity-empty.svg": 90041,
	"./add.svg": 74163,
	"./alert.svg": 43152,
	"./annotations.svg": 85672,
	"./answers-visible.svg": 64534,
	"./answers.svg": 25855,
	"./apps.svg": 66514,
	"./archive.svg": 7192,
	"./arrow-back.svg": 74159,
	"./arrow-double-down.svg": 55910,
	"./arrow-double-up.svg": 61693,
	"./arrow-down-bold.svg": 16222,
	"./arrow-down.svg": 40554,
	"./arrow-downward.svg": 56592,
	"./arrow-drop-down-circle.svg": 98323,
	"./arrow-drop-down.svg": 92950,
	"./arrow-forward.svg": 86537,
	"./arrow-left.svg": 97793,
	"./arrow-right.svg": 21420,
	"./arrow-up-bold.svg": 64415,
	"./arrow-up.svg": 8633,
	"./arrow-upward.svg": 30307,
	"./assignment.svg": 64157,
	"./attachment.svg": 31821,
	"./author.svg": 64207,
	"./auto-fix.svg": 14617,
	"./autorenew.svg": 65650,
	"./bar-chart.svg": 23194,
	"./bold.svg": 34175,
	"./bookmark.svg": 5230,
	"./calender.svg": 58440,
	"./chapter-empty-two-layers.svg": 8343,
	"./chapter-empty.svg": 30901,
	"./checkmark-circle-fill.svg": 60152,
	"./checkmark-circle.svg": 4758,
	"./checkmark.svg": 37241,
	"./clock-progress.svg": 1340,
	"./code-braces.svg": 44826,
	"./code.svg": 60413,
	"./columns-2.svg": 55942,
	"./comment.svg": 73517,
	"./competencies.svg": 75857,
	"./content.svg": 1113,
	"./copy.svg": 69533,
	"./creative-commons.svg": 19056,
	"./cross-circle.svg": 16379,
	"./cross.svg": 16510,
	"./crown.svg": 84559,
	"./cursor.svg": 31616,
	"./dead.svg": 96776,
	"./desktop.svg": 56462,
	"./distribute-columns.svg": 46725,
	"./donut.svg": 46566,
	"./dot.svg": 89539,
	"./double-arrow.svg": 49161,
	"./draw.svg": 79596,
	"./ellipse-outline.svg": 78089,
	"./email.svg": 56778,
	"./enter.svg": 10708,
	"./entree-logo.svg": 56465,
	"./eraser.svg": 93162,
	"./excel.svg": 76095,
	"./exercises.svg": 26731,
	"./exit.svg": 20918,
	"./expand.svg": 31922,
	"./external-link.svg": 54492,
	"./eye-off.svg": 405,
	"./eye.svg": 22721,
	"./feedback-filled.svg": 47404,
	"./feedback.svg": 15027,
	"./file-download.svg": 78701,
	"./file-upload.svg": 49306,
	"./file.svg": 48036,
	"./filter-list.svg": 51401,
	"./find-in-page.svg": 59791,
	"./flash-card.svg": 58723,
	"./folder.svg": 74246,
	"./formula.svg": 20484,
	"./fullscreen-exit.svg": 44450,
	"./fullscreen.svg": 28533,
	"./gift.svg": 45864,
	"./google-drive.svg": 8980,
	"./google-logo-color.svg": 47783,
	"./group-empty.svg": 32451,
	"./heading.svg": 38860,
	"./help-circle.svg": 40860,
	"./home.svg": 10359,
	"./horizontal-align-center.svg": 62140,
	"./hyperlink.svg": 53876,
	"./ideal.svg": 26993,
	"./image.svg": 18613,
	"./indent.svg": 13160,
	"./info-circle.svg": 70195,
	"./italic.svg": 20306,
	"./justify-center.svg": 7212,
	"./justify-left.svg": 36248,
	"./justify-right.svg": 93703,
	"./key.svg": 12227,
	"./keyboard.svg": 8421,
	"./last-modified.svg": 8682,
	"./launch.svg": 30351,
	"./layer-folder.svg": 40146,
	"./learnbeat-no-label.svg": 79969,
	"./learnbeat.svg": 81192,
	"./learning-text.svg": 8988,
	"./leswijs.svg": 97571,
	"./library.svg": 10559,
	"./lightbulb-filled.svg": 62896,
	"./lightbulb-off.svg": 63687,
	"./lightbulb.svg": 48335,
	"./line.svg": 48912,
	"./local-cafe.svg": 97715,
	"./lock.svg": 47047,
	"./lock_open.svg": 13554,
	"./magister-logo.svg": 85604,
	"./menu-right.svg": 7558,
	"./menu.svg": 35391,
	"./merge-layers.svg": 76525,
	"./messageFrom.svg": 68123,
	"./messageTo.svg": 31224,
	"./microphone.svg": 43154,
	"./minus.svg": 43290,
	"./molsketch-benzene.svg": 76018,
	"./molsketch-bond-double.svg": 83166,
	"./molsketch-bond-single.svg": 12373,
	"./molsketch-bond-triple.svg": 45729,
	"./move.svg": 83149,
	"./notifications-active.svg": 76465,
	"./off.svg": 29677,
	"./office365-logo-color.svg": 16940,
	"./one-column.svg": 56901,
	"./orderedlist.svg": 6033,
	"./outdent.svg": 71393,
	"./palette.svg": 3111,
	"./pause-circle.svg": 59185,
	"./pause.svg": 71460,
	"./pen.svg": 72223,
	"./pencil.svg": 45221,
	"./people-plus.svg": 64932,
	"./people.svg": 2203,
	"./periodic-table.svg": 60046,
	"./person-add.svg": 92943,
	"./person.svg": 80797,
	"./phone.svg": 88542,
	"./photo-library.svg": 82000,
	"./place.svg": 44423,
	"./planner.svg": 92722,
	"./play-circle.svg": 6937,
	"./play.svg": 92684,
	"./plus-circle-filled.svg": 96064,
	"./plus-circle.svg": 50847,
	"./portfolio.svg": 79254,
	"./present.svg": 91703,
	"./presentation.svg": 97762,
	"./print.svg": 27663,
	"./progress.svg": 41399,
	"./qrcode.svg": 2568,
	"./queue.svg": 85439,
	"./quote-round.svg": 52629,
	"./quote.svg": 39194,
	"./rect-outline.svg": 45473,
	"./redo-arrow.svg": 62738,
	"./refresh.svg": 18163,
	"./reorder.svg": 47739,
	"./restart.svg": 67423,
	"./results.svg": 95096,
	"./school-building.svg": 67491,
	"./school.svg": 32898,
	"./search.svg": 25158,
	"./section-empty.svg": 24859,
	"./select-copy.svg": 37620,
	"./select-delete.svg": 43318,
	"./send.svg": 31312,
	"./server-saved.svg": 79057,
	"./server-syncing.svg": 87055,
	"./server-unsaved.svg": 94114,
	"./settings.svg": 28213,
	"./share-with-school.svg": 94333,
	"./share.svg": 29203,
	"./show.svg": 60389,
	"./shuffle.svg": 53545,
	"./sign-direction.svg": 81433,
	"./skip-next.svg": 71935,
	"./smartphone.svg": 4623,
	"./somtoday-color.svg": 96374,
	"./source-1.svg": 30719,
	"./source-12.svg": 10415,
	"./source-13.svg": 90366,
	"./source-14.svg": 7745,
	"./source-2.svg": 68044,
	"./source-3.svg": 50637,
	"./source-4.svg": 80418,
	"./source-6.svg": 81184,
	"./source-7.svg": 785,
	"./source-minus-1.svg": 43284,
	"./spinner.svg": 45337,
	"./stack.svg": 39310,
	"./star-rounded.svg": 33206,
	"./stop-circle.svg": 40435,
	"./stop.svg": 26134,
	"./subscript.svg": 73057,
	"./superscript.svg": 61354,
	"./support.svg": 5819,
	"./surf-logo-black.svg": 12908,
	"./swap-arrows.svg": 97906,
	"./swap.svg": 92911,
	"./symbol.svg": 49710,
	"./tab.svg": 78651,
	"./table.svg": 94066,
	"./tag.svg": 53270,
	"./take-in.svg": 98593,
	"./task-1.svg": 28943,
	"./task-11.svg": 97516,
	"./task-16.svg": 54259,
	"./task-2.svg": 49916,
	"./task-21.svg": 15077,
	"./task-22.svg": 83302,
	"./task-25.svg": 52713,
	"./task-26.svg": 7898,
	"./task-28.svg": 74892,
	"./task-29.svg": 22253,
	"./task-30.svg": 13063,
	"./task-31.svg": 49238,
	"./task-32.svg": 37461,
	"./task-33.svg": 64852,
	"./task-34.svg": 74619,
	"./task-35.svg": 14250,
	"./task-36.svg": 5625,
	"./task-39.svg": 63102,
	"./task-6.svg": 11472,
	"./template.svg": 83652,
	"./text.svg": 90563,
	"./theory.svg": 38753,
	"./three-dots.svg": 66795,
	"./time.svg": 24001,
	"./timer.svg": 79777,
	"./training-empty.svg": 62508,
	"./translate.svg": 64736,
	"./trash.svg": 7464,
	"./trend-down.svg": 42260,
	"./trend-stable.svg": 78329,
	"./trend-up.svg": 71183,
	"./trophy.svg": 48492,
	"./two-columns.svg": 32478,
	"./two-rotating-arrows.svg": 20240,
	"./underline.svg": 92930,
	"./undo-arrow.svg": 36068,
	"./unorderedlist.svg": 64202,
	"./update.svg": 36697,
	"./video.svg": 49155,
	"./volume-up.svg": 45050,
	"./warning-fill.svg": 91172,
	"./warning.svg": 78474,
	"./words-menu.svg": 82435,
	"./zoom-in.svg": 9569,
	"./zoom-out.svg": 1808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81487;